import React from 'react';
import { FaAward } from 'react-icons/fa';
import UCF from '../assets/img/certificates/ucf.png';
import PCEP from '../assets/img/certificates/pcep.png';
import PCAP from '../assets/img/certificates/pcap.png';
import Python from '../assets/img/certificates/python.jpg';
import Spring from '../assets/img/certificates/springboot.jpg';
import Wordpress from '../assets/img/certificates/wp.jpg';
import { useTranslate } from 'react-translate';

const Certificates = () => {
  const t = useTranslate('Certificates');

  const certificates = [
    {
      title: 'UCF Coding Bootcamp',
      provider: 'University of Central Florida',
      date: 'June 2022',
      link: 'https://badgr.com/public/assertions/H25wO7OQR0GZrar8Uwsybw',
      img: UCF,
    },
    {
      title: 'PCAP - Certified Associate Python Programmer',
      provider: 'Python Institute',
      date: 'January 2021',
      link: 'https://www.credly.com/badges/6c67f5dd-8222-4e99-a80c-668e9d845594/public_url',
      img: PCAP,
    },
    {
      title: 'PCEP - Certified Entry-Level Python Programmer',
      provider: 'Python Institute',
      date: 'October 2020',
      link: 'https://www.credly.com/badges/7a168258-69af-453b-b9b2-6c4da247ff4d/public_url',
      img: PCEP,
    },
    {
      title: 'The Complete Python Developer',
      provider: 'Udemy',
      date: 'February 2020',
      link: 'https://www.udemy.com/certificate/UC-4afac34e-7da6-4ba1-a3bb-a7f6e5c21f6f/',
      img: Python,
    },
    {
      title: 'Master Spring Boot 3 and Spring Framework 6 with Java',
      provider: 'Udemy',
      date: 'August 2023',
      link: 'https://www.udemy.com/certificate/UC-e984cf59-d576-431e-b041-043321acc3e1/',
      img: Spring,
    },
    {
      title: 'The WordPress and SEO Masterclass with Generative AI 2025',
      provider: 'Udemy',
      date: 'March 2024',
      link: 'https://www.udemy.com/certificate/UC-ba69247a-28df-4712-b4ef-c31da18bdef0/?utm_campaign=email&utm_medium=email&utm_source=sendgrid.com',
      img: Wordpress,
    },
  ];

  return (
    <section id='certificates' className='py-8 md:py-12'>
      <div className='section-shell'>
        <div className='mb-8 max-w-2xl'>
          <div className='section-kicker' data-aos='fade-up' data-aos-delay='50'>
            <FaAward />
            {t('title')}
          </div>
          <h2
            className='section-title mt-6'
            data-aos='fade-up'
            data-aos-delay='100'
          >
            {t('headline')}
          </h2>
          <p
            className='section-copy mt-5'
            data-aos='fade-up'
            data-aos-delay='150'
          >
            {t('subtitle')}
          </p>
        </div>

        <div className='grid gap-6 sm:grid-cols-2 xl:grid-cols-3'>
          {certificates.map((cert, index) => (
            <article
              key={cert.title}
              className='section-card flex h-full flex-col rounded-[1.75rem] p-6'
              data-aos='fade-up'
              data-aos-delay={index * 70}
            >
              <div className='flex items-start justify-between gap-4'>
                <div>
                  <p className='text-sm uppercase tracking-[0.2em] text-[var(--indigo)]'>
                    {cert.date}
                  </p>
                  <h3 className='mt-3 text-xl font-extrabold text-[var(--text-main)]'>
                    {cert.title}
                  </h3>
                  <p className='mt-2 text-sm text-[var(--text-muted)]'>{cert.provider}</p>
                </div>
                <img
                  src={cert.img}
                  alt={cert.title}
                  className='h-16 w-16 rounded-2xl object-cover'
                />
              </div>

              <div className='mt-6'></div>

              <a
                href={cert.link}
                target='_blank'
                rel='noreferrer'
                className='secondary-link mt-auto w-fit'
              >
                {t('button')}
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certificates;
